<div class="main">
  <div class="header">
    {{'BIDORDER.bid_order' | translate}}
    <i class="material-icons" (click)="close()">clear</i>
  </div>
  <div class="biddingData">
    <div *ngIf="!accepted">
      <div style="font-family: 'Inter'; color: #424242; font-size: 20px;padding-bottom:20px;"> Bidding Rules</div>
      <div class="rules-container" style="padding: 0px 0px 20px 20px;">
        <div *ngFor="let rule of rules; let i = index"
          style="font-family: 'Inter'; color: #424242; font-size: 16px; padding-bottom: 6px; display: flex;">
          <div>
            {{ i + 1 }}.
          </div>
          <div style="padding-left: 8px;">{{ rule.trim() }}</div>
        </div>
      </div>
      <div class="newButton" (click)="accepted = true" style=" color: #fff; background: #631c4f;;"> Accept Rules</div>
    </div>
    <div *ngIf="accepted">
      <div class="order">
        <span style="font-family: 'Inter'; color: #757575; font-size: 16px;">{{'OPEN_BID.order' | translate}} : </span>
        <p style="font-family: 'Inter'; font-size: 16px; font-weight: 500;">{{ selectedOrderData.order }}</p>
      </div>
      <div style="padding: 0px 0px 20px 0px;">
        <span *ngFor="let pick of selectedOrderData.from; let i=index; let onlyFirst = first">
          <strong style="color: #0B7D2E;">P{{i+1}}</strong> - {{pick.loc_id.name}} {{pick.loc_id.city}}<br>
          <span style="color: #757575;font-size: 14px;"> {{ getFormattedArea(pick.loc_id.area) }}</span><br>
          <div *ngIf="onlyFirst" style="font-size: 11px; color: black;margin-top: 3px;">{{'OPEN_BID.date' | translate}} : {{selectedOrderData.pickDate}}</div>
          <span *ngIf="(selectedOrderData.length > 1) && (i != selectedOrderData.length-1)">,</span>
        </span>
      </div>
      <div style="padding: 0px 0px 20px 0px;">
        <span *ngFor="let delivery of selectedOrderData.to; let i=index">
          <b style="color: #D8511F;">D{{i+1}}</b> -  {{delivery.loc_id.name}} - {{delivery.loc_id.city}}<br>
          <span style="color: #757575;font-size: 14px;"> {{ getFormattedArea(delivery.loc_id.area) }}</span><br>
          <span *ngIf="(selectedOrderData.length > 1) && (i != selectedOrderData.length-1)">,</span>
        </span>
      </div>
      <div style="padding: 0px 0px 20px 0px;">
          <span style="color: #757575;">{{'OPEN_BID.vehType' | translate}} : </span><strong> {{ selectedOrderData.vehicle.name }}</strong>
      </div>
      <div class="vehicles" *ngIf="!selectedOrderData.weight_based" style="padding: 0px 0px 20px 0px;">
        <div>
            <span style="color: #757575;">{{'BIDORDER.no_of_vehicles' | translate}}: </span>
            <strong>{{selectedOrderData.req_no_of_vehicles}}</strong>
        </div>
        <div *ngIf="selectedOrderData.cancelled_vehicles" style="color: red;">
            <span style="color: #757575;">{{'BIDORDER.cancelled' | translate}}: </span>
            <strong>{{selectedOrderData.cancelled_vehicles}}</strong>
        </div>
      </div>
      <div class="weight" *ngIf="selectedOrderData.weight_based" style="padding: 0px 0px 20px 0px;">
          <span style="color: #757575;">{{'BIDORDER.weight_requested' | translate}}: </span>
          <strong>{{selectedOrderData.shipmentWeight}} {{selectedOrderData.uom | titlecase}}</strong>
      </div>
      <div class="biddingLow" *ngIf="data.bid_flow !== 'rfq'"  [ngStyle]="{'background-color': '#E54131'}">
        <span>{{ data.bid_flow !='tender' ? 'BIDORDER.lowestBid' : 'Base Price' | translate}} {{currencySymbol}} {{selectedOrderData.lowest_bid_amount
          |numberFormat:selectedOrderData.lowest_bid_amount}}</span>
      </div>
      <div class="bidForm">
        <mat-card>
          <div *ngIf="data.bid_flow!='tender' && data.bid_flow!='rfq'">
            <mat-checkbox [(ngModel)]="bidData.auto" (change)="onChange($event)">{{'BIDORDER.autoBid' |
              translate}}
            </mat-checkbox>
          </div>

          <div class="amount">
            <mat-form-field class="bidInputs">
              <input matInput placeholder="Amount {{currencySymbol}}" name="amount" [(ngModel)]="bidData.amount">
              <mat-hint *ngIf="data.bid_flow!='tender' && data.bid_flow!='rfq'" align="end">{{'BIDORDER.lessAmount' | translate}} {{currencySymbol}} {{max_bid_amount
                |numberFormat:max_bid_amount}}</mat-hint>

            </mat-form-field>
          </div>
          <div class="floor_amount" [hidden]="!bidData.auto">
            <mat-form-field class="bidInputs">
              <input matInput placeholder="Floor Amount {{currencySymbol}}" name="floor_amount"
                [(ngModel)]="bidData.floor_amount" style="font-size: 20px;">
            </mat-form-field>
          </div>
          <div class="decrement_amount" [hidden]="!bidData.auto">
            <mat-form-field class="bidInputs">
              <input matInput placeholder="Decrement Amount {{currencySymbol}}" name="decrement_amount"
                [(ngModel)]="bidData.decrement_amount">
              <mat-hint align="end" *ngIf="data.bid_flow!='rfq'">{{'BIDORDER.decrementAmount' | translate}} {{currencySymbol}} {{min_bid_diff
                |numberFormat:min_bid_diff}}</mat-hint>
            </mat-form-field>
          </div>
        </mat-card>
      </div>
      <div class="action-btns" *ngIf="!isBidOrderExpired">
        <div class="submitButton">
          <div class="bidbutton" (click)="bid()">
            {{'BIDORDER.bid' | translate}}
          </div>
        </div>
      </div>
      <div class="action-btns" *ngIf="isBidOrderExpired">
        <div class="submitButton">
          <p style="font-size: 15px; color: #999;">{{'BIDORDER.expired' | translate}}</p>
        </div>
      </div>
    </div>
  </div>
</div>